import { host } from "../../../public/config.json";
import wx from 'weixin-js-sdk'
export const wxConfig = function (ops, callback, error) {
  console.log("wxConfig1")
  let timerID = setTimeout(() => {
    if (typeof error == "function") {
      error("超时");
    }
  }, 500);
  console.log("wxConfig2")
  wx.config({
    appId: ops.cfg.appId,
    debug: false,
    jsApiList: ["checkJsApi", "getLocation"],
    nonceStr: ops.cfg.nonceStr,
    signature: ops.cfg.signature,
    timestamp: ops.cfg.timestamp
  });
  console.log("wxConfig3")
  wx.ready(function () {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    wx.checkJsApi({
      jsApiList: ['getLocation'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res) {
      }
    })
    wx.getLocation({
      type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
        var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
        var speed = res.speed; // 速度，以米/每秒计
        var accuracy = res.accuracy; // 位置精度
        localStorage.setItem("latitude", latitude);
        localStorage.setItem("longitude", longitude);
        if (typeof callback == "function") {
          callback();
        }
      },
      fail: (err) => {
        if (typeof error == "function") {
          error();
        }
        console.log("fail", err);
      },
      complete: (resp) => {
        clearTimeout(timerID);
      },
    })
  });
}

export const wxConfigShare = function (ops, shareType, shareTitle, shareLink) {
  wx.config({
    appId: ops.cfg.appId,
    debug: false,
    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "checkJsApi"],
    nonceStr: ops.cfg.nonceStr,
    signature: ops.cfg.signature,
    timestamp: ops.cfg.timestamp
  });
  wx.ready(function () {
    wx.checkJsApi({
      jsApiList: ['updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res) {
      }
    })
    // 分享给朋友
    wx.updateAppMessageShareData({
      title: shareType, // 分享标题
      desc: shareTitle, // 分享描述
      link: shareLink,
      imgUrl: host + "/img2/option1.jpg", // 分享图标
      success: function () {
        // 设置成功
      },
      fail(err) {
        // 失败
        console.log("fail", err)
      },
    })
    // 分享到朋友圈 shareType + '-' + shareTitle
    wx.updateTimelineShareData({
      title: shareTitle,
      link: shareLink,
      imgUrl: host + "/img2/option1.jpg",
      success: function () {
        // 设置成功
      }
    })
  })
}
